import type { Translator } from '@porotutu/i18n'
import type { Permit } from '@porotutu/react/permit'
import type { LucideIcon } from 'lucide-react'
import type { NavGroup } from './Sidebar'

export type NavEntry = string | { slice: string; path?: string; labelKey?: string }

export type NavGroupSpec = { key: string; slices: readonly NavEntry[] }

const entryOf = (entry: NavEntry) => (typeof entry === 'string' ? { slice: entry } : entry)

export function navGroupsFor(
  groups: readonly NavGroupSpec[],
  {
    t,
    permissions,
    icons = {},
  }: {
    t: Translator
    permissions: Permit
    icons?: Readonly<Record<string, LucideIcon>>
  },
): NavGroup[] {
  return groups.map((group) => ({
    key: group.key,
    title: t(`layouts.main.nav_groups.${group.key}`),
    links: group.slices
      .map(entryOf)
      .filter(({ slice }) => permissions.reads(slice))
      .map(({ slice, path, labelKey }) => ({
        to: path ?? `/${slice}`,
        label: t(labelKey ?? `layouts.main.nav_${slice}`),
        icon: icons[slice],
      })),
  }))
}
